import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

import { SUPERVISOR_DASHBOARD_QUERY_KEY } from './use-supervisor-dashboard';

// Item 335 — atribui uma conversa sem dono a um atendente. No sucesso invalida a
// listagem de conversas (a conversa sai do pool sem-dono) e o dashboard do
// supervisor (a carga do atendente muda).
export function useAssignConversation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { conversationId: string; assignToUserId: string; reason?: string }) =>
      api.assignConversation(vars.conversationId, {
        assignToUserId: vars.assignToUserId,
        ...(vars.reason !== undefined && vars.reason !== '' ? { reason: vars.reason } : {}),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['conversations'] });
      void qc.invalidateQueries({ queryKey: SUPERVISOR_DASHBOARD_QUERY_KEY });
    },
  });
}
